import React, { useState, useEffect } from 'react';
import { Pagination, Empty } from 'antd';
import ViewClassComponent from '../ViewClassComponent/ViewClassComponent';
import './ClassesList.css';
import axiosInstance from '../../Config/axiosConfig';

function ClassesList({ educationLevelId, subjectId, searchQuery }) {
  const [allClasses, setAllClasses] = useState([]);
  const [filteredClasses, setFilteredClasses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [displayClasses, setDisplayClasses] = useState([]);

  const isFiltering = Boolean(subjectId || educationLevelId);

  useEffect(() => {
    if (isFiltering && currentPage !== 1) {
      setCurrentPage(1);
    } else {
      fetchClasses();
    }
  }, [currentPage, educationLevelId, subjectId]);

  const fetchClasses = async () => {
    setLoading(true);
    try {
      const payload = {
        pageNumber: currentPage,
        pageSize: isFiltering ? 1000 : 15,
      };

      if (subjectId) payload.subjectId = subjectId;
      if (educationLevelId) payload.educationClass = educationLevelId;

      const response = await axiosInstance.post('/Public/get-paged-classes', payload);
      
      if (response.data?.data?.classes) {
        setAllClasses(response.data.data.classes);
        setTotalPages(response.data.data.pages || 1);
      } else {
        setAllClasses([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.error('Error fetching classes:', error);
      setAllClasses([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      const filtered = allClasses.filter(classItem => {
        return (
          (classItem.title && classItem.title.toLowerCase().includes(query)) ||
          (classItem.instructor && classItem.instructor.toLowerCase().includes(query)) ||
          (classItem.education_class && classItem.education_class.toLowerCase().includes(query))
        );
      });
      setFilteredClasses(filtered);
    } else {
      setFilteredClasses(allClasses);
    }
  }, [searchQuery, allClasses]);

  useEffect(() => {
    setDisplayClasses(searchQuery ? filteredClasses : allClasses);
  }, [searchQuery, filteredClasses, allClasses]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const WireframeLoader = () => (
    <div className="grid-container" aria-busy="true" aria-live="polite">
      {[...Array(16)].map((_, i) => (
        <div key={i} className="wireframe-card">
          <div className="wireframe-image pulse-animation" />
          <div className="wireframe-line pulse-animation" style={{ width: '60%' }} />
          <div className="wireframe-line pulse-animation" style={{ width: '80%', animationDelay: '0.2s' }} />
          <div className="wireframe-line pulse-animation" style={{ width: '70%', animationDelay: '0.4s' }} />
        </div>
      ))}
    </div>
  );

  return (
    <div className="classes-list-container">
      {loading ? (
        <WireframeLoader />
      ) : (
        <>
          {displayClasses.length > 0 ? (
            <>
              <div className="category-hor-list-grid">
                {displayClasses.map((classItem) => (
                  <ViewClassComponent 
                    key={classItem.id} 
                    name={classItem.title}
                    classData={classItem} 
                  />
                ))}
              </div>
              {!isFiltering && !searchQuery && (
                <div className="pagination">
                  <Pagination
                    current={currentPage}
                    total={totalPages * 15}
                    pageSize={15}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="empty-state-container">
              <div className="empty-state">
                <Empty description={
                  searchQuery 
                    ? "No classes match your search. Try different keywords" 
                    : "Classes Coming soon, we will keep you updated for the upcoming classes"
                } />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default ClassesList;